<template>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path
      fill="#142ACC"
      fill-rule="evenodd"
      d="M4.317 1.5A2.817 2.817 0 0 0 1.5 4.317v15.366A2.817 2.817 0 0 0 4.317 22.5h15.366a2.817 2.817 0 0 0 2.817-2.817V4.317A2.817 2.817 0 0 0 19.683 1.5H4.317Zm12.567 8.083a1.024 1.024 0 1 0-1.573-1.312l-4.404 5.285-1.768-1.768a1.024 1.024 0 0 0-1.449 1.448l2.561 2.561a1.024 1.024 0 0 0 1.512-.068l5.121-6.146Z"
      clip-rule="evenodd"
    />
  </svg>
</template>
